import React from "react";
import {
  RiUserFollowFill,
  RiShoppingBasketFill,
  RiDeleteBin2Fill,
} from "react-icons/ri";
import { MdSell } from "react-icons/md";
import UserTable from "./UserTable";

const DisplayDeshboard = ({
  orders,
  users,
  admins,
  products,
  setIsUserDeleted,
}) => {
  const ordersLength = orders?.length;
  const usersLength = users?.length;
  const productsLenght = products?.length;
  return (
    <section className="desh-main-display">
      <article className="display-flex-site-info">
        <div className="inside-dis-info-single inside-dis-info-sinGreen">
          <div className="inside-info-single-items-flex">
            <h1>{usersLength}</h1>
            <p>Registered User</p>
            <p>
              {admins.length === 1 ? "Total Admin":"Total Admins"}
               : {admins.length}
            </p>
          </div>
          <div>
            <button className="inside-dis-info-single-icon">
              <RiUserFollowFill />
            </button>
          </div>
        </div>
        <div className="inside-dis-info-single inside-dis-info-sinOrange">
          <div className="inside-info-single-items-flex">
            <h1>{productsLenght}</h1>
            <p>Total Products</p>
          </div>
          <div>
            <button className="inside-dis-info-single-icon">
              <MdSell />
            </button>
          </div>
        </div>
        <div className="inside-dis-info-single inside-dis-info-sinBlue">
          <div className="inside-info-single-items-flex">
            <h1>{ordersLength}</h1>
            <p>Total Orders</p>
          </div>
          <div>
            <button className="inside-dis-info-single-icon">
              <RiShoppingBasketFill />
            </button>
          </div>
        </div>
      </article>
      <UserTable users={users} setIsUserDeleted={setIsUserDeleted} />
    </section>
  );
};

export default DisplayDeshboard;
